"use client";

import { useRequiresCookieConsent } from "@context/DomainContext";
import { Analytics, GTMData } from "@types";
import { sendGTMTrackingEvent } from "@utils/analyticsUtils";
import { getCookieConsent } from "@utils/helpers";
import { useEffect, useRef } from "react";

export default function TrackGTMPageView({
  pageTitle,
  config,
}: {
  pageTitle: string;
  config: Analytics[];
}) {
  const pageviewTriggered = useRef(false);
  const requiresCookieConsent = useRequiresCookieConsent();

  useEffect(() => {
    if (typeof window !== "undefined" && !pageviewTriggered.current) {
      const data: GTMData = {
        event: "page_view",
        page_title: pageTitle,
      };

      if (requiresCookieConsent) {
        const cookieConsent = getCookieConsent();
        if (cookieConsent?.marketing) {
          sendGTMTrackingEvent(data, config);
          pageviewTriggered.current = true;
          return;
        }

        const handleCookiebotAccept = () => {
          if (!pageviewTriggered.current) {
            const cookieConsent = getCookieConsent();
            if (cookieConsent?.marketing) {
              sendGTMTrackingEvent(data, config);
              pageviewTriggered.current = true;
            }
          }
        };
        window.addEventListener("CookiebotOnAccept", handleCookiebotAccept);

        return () => {
          window.removeEventListener(
            "CookiebotOnAccept",
            handleCookiebotAccept
          );
        };
      } else {
        sendGTMTrackingEvent(data, config);
        pageviewTriggered.current = true;
      }
    }
  }, [pageTitle, config, requiresCookieConsent]);

  return null;
}
